
var formatter = require('../../formatter/formatter.js');
var constants = require('../../domain/constants.js');
var localizationUtils = require('../../../utils/domain/localizationUtils')
var stringUtil = require('../../string/stringUtil.js');
var discountUtility = require('./discountUtility.js');

const validator = require('../../validator/validator');


module.exports.isSalePartiallyOrFullyPaid = function (sale)
{
    return (sale.paidAmount ?? 0) > 0;
}

module.exports.isSaleFullyPaid = function (sale)
{
    return this.calculateRemainingPayableAmount(sale) <= constants.numericThresholdValue;
}

module.exports.calculateTotalRetailOrderPrice = function (sale)
{
    let totalRetailOrderPrice = this.calculateTotalOrderPrice(sale);

    if (localizationUtils.isVatInclusive())
    {
        totalRetailOrderPrice -= this.calculateTotalOrderVAT(sale);
    }

    return totalRetailOrderPrice;
}

module.exports.calculateTotalOrderPrice = function(sale)
{
    if (sale == null || sale.saleItems == null || sale.saleItems.length <= 0)
        return 0;
    
    var saleTotal = 0;
    sale.saleItems.forEach (saleItem =>
    {
        saleTotal = this.roundNumericValue(saleTotal + this.calculateTotalItemPrice(saleItem));
    });

    return saleTotal;
}

module.exports.calculateTotalOrderVAT = function(sale)
{
    if (sale == null || sale.saleItems == null || sale.saleItems.length <= 0)
        return 0;
    
    var vatTotal = 0;
    sale.saleItems.forEach (saleItem =>
    {
        vatTotal = this.roundNumericValue(vatTotal + this.calculateTotalItemVAT(saleItem));
    });

    return vatTotal;
}

module.exports.calculateTotalItemPrice = function(saleItem, exclusionTags)
{
    if (this.isExclusionApplicable(exclusionTags, saleItem))
        return 0;

    var saleTotal = this.roundNumericValue(saleItem.unitPrice * saleItem.quantity);
    
    saleItem.saleItems.forEach (saleItem =>
    {
        saleTotal = this.roundNumericValue(saleTotal + this.calculateTotalItemPrice(saleItem, exclusionTags));
    });

    return saleTotal;
}

module.exports.calculateTotalItemVAT = function(saleItem)
{
    var vatTotal = this.roundNumericValue(saleItem.vat * saleItem.quantity);
    
    saleItem.saleItems.forEach (saleItem =>
    {
        vatTotal = this.roundNumericValue(vatTotal + this.calculateTotalItemVAT(saleItem));
    });

    return vatTotal;
}

module.exports.calculateTotalServiceCharges = function(sale)
{
    if (sale == null || sale.charges == null || sale.charges.length <= 0)
        return 0;
   
    var chargesTotal = 0;
   
    sale.charges.forEach (charge =>
        {
            if (charge.type == null || !charge.type.toLowerCase().includes("service"))
                return;
                
            chargesTotal = this.roundNumericValue(chargesTotal + charge.amount);
        });

    return chargesTotal;
}

module.exports.calculateTotalDeliveryCharges = function(sale)
{
    if (sale == null || sale.charges == null || sale.charges.length <= 0)
        return 0;

    var chargesTotal = 0;
    
    sale.charges.forEach (charge =>
        {
            if (charge.type == null || !charge.type.toLowerCase().includes("delivery"))
                return;
                
            chargesTotal = this.roundNumericValue(chargesTotal + charge.amount);
        });

    return chargesTotal;
}

module.exports.calculateTotalTipCharges = function(sale)
{
    if (sale == null || sale.charges == null || sale.charges.length <= 0)
        return 0;

    var chargesTotal = 0;
    
    sale.charges.forEach (charge =>
        {
            if (charge.type == null || !charge.type.toLowerCase().includes("tip"))
                return;
                
            chargesTotal = this.roundNumericValue(chargesTotal + charge.amount);
        });

    return chargesTotal;
}

module.exports.calculateTotalCharges = function(sale)
{
    if (sale == null || sale.charges == null || sale.charges.length <= 0)
        return 0;

    var chargesTotal = 0;
    
    sale.charges.forEach (charge =>
        {
            chargesTotal = this.roundNumericValue(chargesTotal + charge.amount);
        });

    return chargesTotal;
}

module.exports.calculateTotalChargesVAT = function(sale)
{
    if (sale == null || sale.charges == null || sale.charges.length <= 0)
        return 0;

    var vatTotal = 0;
    
    sale.charges.forEach (charge =>
        {
            vatTotal = this.roundNumericValue(vatTotal + charge.vat);
        });

    return vatTotal;
}

module.exports.calculateTotalVAT = function(sale)
{
    return this.roundNumericValue(this.calculateTotalOrderVAT(sale) + this.calculateTotalChargesVAT(sale));
}


module.exports.calculateTotalDiscounts = function(sale)
{
    if (sale == null || sale.discounts == null || sale.discounts.length <= 0)
        return 0.0;

    var discountsTotal = 0;
    
    sale.discounts.forEach (discount =>
    {
        discountsTotal = this.roundNumericValue(discountsTotal + discount.amount);
    });

    return discountsTotal;
}


module.exports.calculateTotalSalePrice = function(sale)
{
    return this.roundNumericValue(this.calculateTotalOrderPrice(sale) + this.calculateTotalCharges(sale));
}

module.exports.calculateTotalNetSalePrice = function(sale)
{
    var totalNetSalePrice =  this.roundNumericValue(this.calculateTotalSalePrice(sale) - this.calculateTotalDiscounts(sale));
    if (!localizationUtils.isVatInclusive())
    {
        totalNetSalePrice = this.roundNumericValue(totalNetSalePrice + 
                                                   this.calculateTotalOrderVAT(sale) +
                                                   this.calculateTotalChargesVAT(sale));
    }
    return totalNetSalePrice;
}

module.exports.calculateTotalPaidAmount = function (sale)
{
    return this.roundNumericValue(sale.paidAmount ?? 0);
}

module.exports.calculateRemainingPayableAmount = function(sale)
{
    return this.roundNumericValue(this.calculateTotalNetSalePrice(sale) - (sale.paidAmount ?? 0));
}

module.exports.calculateRefundsPriceForItem = function(saleItem)
{
    if (saleItem.isRefunded)
        return 0;

    var refundsPrice = this.roundNumericValue(saleItem.unitPrice * saleItem.quantity);
    if (!localizationUtils.isVatInclusive())
        refundsPrice = refundsPrice + this.roundNumericValue(saleItem.vat * saleItem.quantity);

    saleItem.saleItems.forEach (childSaleItem =>
    {
        refundsPrice = this.roundNumericValue(refundsPrice + this.calculateRefundsPriceForItem(childSaleItem));
    });

    return refundsPrice;
}

module.exports.calculateTotalRefunds = function(sale)
{
    var totalRefunds = 0;

    if (sale == null || sale.refunds == null)
        return totalRefunds;

    sale.refunds.forEach (refund =>
    {
        totalRefunds = totalRefunds + refund.refundAmount;
    });

    return totalRefunds;
}

module.exports.calculateTotalRefundableAmount = function (sale)
{
    let paidAmount = sale.paidAmount ?? 0;
    if (paidAmount <= constants.numericThresholdValue)
        return 0;

    return this.roundNumericValue(paidAmount - this.calculateTotalRefunds(sale));
}

module.exports.isSaleFullyRefunded = function (sale)
{
    return (sale.paidAmount ?? 0) > 0 && this.calculateTotalRefundableAmount(sale) <= constants.numericThresholdValue;
}

module.exports.calculateTotalCashRefundable = function(sale)
{
    return this.calculateRefundableForPaymentType(sale, constants.PaymentMethodCash);
}

module.exports.calculateTotalCreditCardRefundable = function(sale)
{
    return this.calculateRefundableForPaymentType(sale, constants.PaymentMethodCredit);
}

module.exports.calculateRefundableForPaymentType= function(sale, paymentType)
{
    var totalCharges = 0;
    var totalRefunds = 0;
    sale.receiptLines.forEach (r =>
        {
            var line = JSON.parse(r.line);
            if (r.type == constants.ReceiptLineTypeCharge && line.mode == paymentType)
                totalCharges = totalCharges + (r.amount * 1);
            
            if (r.type == constants.ReceiptLineTypeRefund && line.mode == paymentType)
                totalRefunds = totalRefunds + (r.amount * 1);
        });

    return this.roundNumericValue(totalCharges - totalRefunds);
}

module.exports.calculateTotalSalePriceForSakeOfApplyingDiscounts = function(sale, discountCode)
{
    if (sale == null || sale.saleItems == null || sale.saleItems.length <= 0)
        return 0.0;
  
    var saleTotal = 0;
    sale.saleItems.forEach (saleItem =>
    {
        saleTotal = this.roundNumericValue(saleTotal + this.calculateTotalSalePriceOfItemForSakeOfApplyingDiscounts(saleItem, discountCode));
    });

    return saleTotal;
}

module.exports.calculateTotalSalePriceOfItemForSakeOfApplyingDiscounts = function(saleItem, discountCode)
{
    var exclusionTags = discountUtility.getDiscountExcludedTags(discountCode);
    return this.roundNumericValue(this.calculateTotalItemPrice(saleItem, exclusionTags));
}



module.exports.isExclusionApplicable = function(exclusionTags, saleItem)
{
    if (stringUtil.isStringNullOrEmpty(exclusionTags) || stringUtil.isStringNullOrEmpty(saleItem.paramsJson))
        return false;

    var configuration = JSON.parse(saleItem.paramsJson);
    if (configuration == null || configuration.discountConfiguration == null || configuration.discountConfiguration.discountTags == null)
        return false;

    var itemDiscountTags =  configuration.discountConfiguration.discountTags.split(",");
    for (var index = 0; index < itemDiscountTags.length; index++)
    {
        var itemDiscountTag = itemDiscountTags[index];
        if (stringUtil.isStringNullOrEmpty(itemDiscountTag)) continue;
        if (exclusionTags.toLowerCase().trim().includes(itemDiscountTag.toLowerCase().trim()))
            return true;
    }

    return false;
}

module.exports.calculateTotalCoversSales = function (sales)
{
    if (!Array.isArray(sales)) sales = [sales];

    let totalSalePriceIncTax = 0;
    let totalNumberOfGuests = 0;

    sales = sales.filter(sale => sale.dispatchType === constants.DispatchTypeDineIn && validator.isNumeric(sale.noOfGuests) && sale.noOfGuests > 0);

    sales.forEach(sale =>
    {
        totalSalePriceIncTax += sale.salePriceIncTax;
        totalNumberOfGuests += sale.noOfGuests;
    });

    return { totalNumberOfGuests, totalSalePriceIncTax };
}







module.exports.roundNumericValue = function(number)
{
    return formatter.roundUp(number, 2);
}
